import type { ReactNode } from 'react'
import type { IndexTapeItem } from '@/lib/market/types'

import Link from 'next/link'
import { cn } from '@/lib/utils'
import { formatLevel } from '@/lib/market/format'
import { ChangeText } from '@/components/market/change'
import { useIndexQuote, usePriceFlash } from '@/components/market/live-provider'

const IndexChip = ({ item }: { item: IndexTapeItem }): ReactNode => {
    const quote = useIndexQuote(item.live)
    const flash = usePriceFlash(quote.level)

    return (
        <Link
            href={`/indices#${item.code.toLowerCase()}`}
            className={cn('flex items-center gap-2 whitespace-nowrap rounded px-1.5 py-0.5 text-xs transition-colors hover:bg-secondary', flash)}
            title={item.name}
        >
            <span className='font-medium text-muted-foreground'>{item.short}</span>
            <span className='font-medium tabular-nums text-foreground'>{formatLevel(quote.level)}</span>
            <ChangeText value={quote.changePct} />
        </Link>
    )
}

const IndexStrip = ({ items, className }: { items: IndexTapeItem[], className?: string }): ReactNode => {
    if (!items.length) return null

    return (
        <div className={cn('flex items-center gap-1', className)}>
            {items.map(item => <IndexChip key={item.code} item={item} />)}
        </div>
    )
}

export default IndexStrip
